var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "myModal",
      staticClass: "fixedModal",
      attrs: {
        size: "lg",
        id: "modal1",
        title: _vm.title,
        centered: "",
        "hide-footer": true,
        "no-close-on-backdrop": true
      },
      on: { hidden: _vm.onHidden }
    },
    [
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _vm.notifications.length == 0
            ? _c("div", [
                _vm._v("\n          No tienes ninguna notificación.\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.notifications, function(notification) {
            return _c(
              "b-card",
              {
                key: notification.id,
                class: notification.leido ? "" : "alert-info"
              },
              [
                _c("b-card-title", {
                  domProps: {
                    innerHTML: _vm._s(notification.id_notificacion.titulo)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(notification.id_notificacion.mensaje)
                  }
                }),
                _vm._v(" "),
                !_vm.alert
                  ? _c(
                      "b-row",
                      { staticClass: "top-buttons" },
                      [
                        _c(
                          "b-col",
                          { staticStyle: { "text-align": "right" } },
                          [
                            notification.leido
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.noLeido(notification)
                                      }
                                    }
                                  },
                                  [_vm._v("Marcar como no leído")]
                                )
                              : _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.leido(notification)
                                      }
                                    }
                                  },
                                  [_vm._v("Marcar como leído")]
                                ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.eliminar(notification)
                                  }
                                }
                              },
                              [_vm._v("Eliminar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Notifications.vue?vue&type=template&id=1c25355a&
// module id = null
// module chunks = 